import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { FeedActivityItem } from '@components/Feed/Activities/FeedActivityItem';
import { PlaylistPreview as PlaylistPreview } from '@components/Playlists/Preview';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, ReleasesAddedToPlaylistFragmentDoc } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleasesAddedToPlaylist on ReleasesAddedToShelfAggregate {
    releasesAdded {
      id
    }
    shelf {
      user {
        id
        ...UserActivityDetail
      }
      id
      ...PlaylistPreview
    }
    ...PlaylistNewReleases
  }
`);

export const ReleasesAddedToPlaylist = ({
  activityFrag,
  timeStamp,
}: {
  activityFrag: FragmentType<ReleasesAddedToPlaylistFragmentDoc>;
  timeStamp: number;
}) => {
  const activity = getFragment(ReleasesAddedToPlaylistFragmentDoc, activityFrag);

  const { shelf: playlist, releasesAdded } = activity;

  const releasesCount = releasesAdded.length;

  const subText =
    releasesCount === 1
      ? 'Added a song to a playlist'
      : `Added ${releasesCount} songs to a playlist`;

  if (!playlist) {
    return null;
  }
  return (
    <FeedActivityItem
      dropdownContent={null}
      userFrag={playlist.user}
      description={subText}
      timestamp={timeStamp}
      isPost={false}
    >
      {!!playlist && !!activity && (
        <PlaylistPreview playlistFrag={playlist} newReleasesFrag={activity} />
      )}
    </FeedActivityItem>
  );
};
